/**
 * Add new properties to an object, replacing the original with a new one
 * Useful for Redux reducers
 *
 * @param {T} object
 * @param {Object} properties
 * @returns {T}
 */
export function updateObject<T>(object: T, properties: Object): T {
  return Object.assign({}, object, properties)
};

/**
 * Update a collection with a new member, replacing the original with a new one
 * Useful for redux reducers
 *
 * @param {A[]} collection
 * @param {A} item
 * @param {number} index
 * @returns {A[]}
 */
export function updateCollection<A>(collection: A[], newItem: A, index: number): A[] {
  const lastCollectionIndex = collection.length - 1;
  if (index > lastCollectionIndex) {
    index = lastCollectionIndex;
  }
  return collection.map((item: A, itemIndex: number) => {
    if (index === itemIndex) {
      return newItem;
    }

    return item;
  })

  return [];
}

/**
 * Get an object from a collection by a property using its key-value pair
 */
export function getObjectByProperty<T, U>(objs: T[], prop: string, value: U): T | null {
  const index: number = getObjectIndexByProperty(objs, prop, value);

  if (index === -1) {
    return null;
  }

  return objs[index];
}

/**
 * Get an object index from a collection by a property using its key-value pair
 *
 * @param {T[]} objs
 * @param {string} prop
 * @param {U} value
 * @returns {number}
 */
export function getObjectIndexByProperty<T, U>(objs: T[], prop: string, value: U): number {
  return objs.map((obj: T) => {
    if ((<any>obj)[prop]) {
      return (<any>obj)[prop];
    }

    return null;
  }).indexOf(value);
}
